<template lang="html">
    <div id="business"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <navBar :tags="tags" :title="titleName" :subTitle="subTitle" :btnAdd="true"
                @btnAdd="handleAddClick"  />
        <div style="width: 100%;">
            <el-form label-width="100px">
                <el-row>
                    <el-row style="margin-top: 10px">
                    <el-col :span="12" style="position: relative">
                        <span style="font-weight: bold;display: inline-block;width:70px;margin-right: 10px">日期</span>
                            <div style="display: inline-block;width: calc(100% - 120px )">
                                <el-date-picker
                                        format="yyyy-M-d"
                                        value-format="yyyy-MM-dd"
                                        v-model="start_time"
                                        type="date"
                                        placeholder="选择日期"
                                        style="width: 45%">
                                </el-date-picker><span style="display: inline-block;width: 10%;text-align: center">至</span><el-date-picker
                                        v-model="end_time"
                                        format="yyyy-M-d"
                                        value-format="yyyy-MM-dd"
                                        type="date"
                                        placeholder="选择日期"
                                        style="width: 45%">
                                </el-date-picker>
                            </div>
                    </el-col>
                    <el-col :span="12" style="text-align: right" v-if="this.role!='staff'">
                        <span style="line-height: 40px;font-weight: bold;margin-right: 10px">人员</span>
                            <el-select v-if="title !== '管理员'" v-model="selectPeople" clearable
                                       v-on:change="handleSelectInputClick"
                                       :disabled="title !== '管理员'"
                                       placeholder="" style="width: 160px">
                                <el-option v-for="item,index in options" :key="item.user_id"
                                           :label="item.user_name"
                                           :value="item.user_id">
                                </el-option>
                            </el-select>
                        <inputSelect :handleSelectInput="handleSelectInputClick" v-if="title === '管理员'"></inputSelect>
                    </el-col>

                    </el-row>
                    <el-row>
                        <el-col :span="12" style="position: relative;margin-top: 19px;">
                            <span style="font-weight: bold;margin-right: 10px;display: inline-block;width: 70px">经销商</span>
                            <el-input v-model="distributor_name" placeholder="请输入经销商名称"
                                      style="width:calc(100% - 120px)"></el-input>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12" style="margin-top: 20px">
                            <span style="font-weight: bold;display: inline-block;width: 70px;margin-right: 10px">
                                联系人</span>
                            <el-input v-model="contact_name" placeholder="请输入联系人姓名"
                                      style="width:calc(100% - 120px)"></el-input>
                        </el-col>
                    </el-row>
                </el-row>
            </el-form>
        </div>
        <el-row style="margin-top:90px;border-bottom: 2px dotted rgb(231, 234, 236);padding-bottom: 20px;">
            <el-button size="small" type="primary" @click.stop="handleQueryClick">查询</el-button>
            <el-button size="small" type="danger" @click.stop="handleResetClick">重置</el-button>
        </el-row>
        <el-table
                :header-cell-style="{'color':'black','font-size':'15px'}"
                :data="tableData"
                border
                style="width: 100%;margin-top: 20px"
                stripe>
            <el-table-column
                    align="center"
                    type="index"
                    label="序号"
                    width="60px">
            </el-table-column>
            <el-table-column
                    prop="activity_date"
                    sortable
                    label="日期"
                    width="130px">
            </el-table-column>
            <el-table-column
                    min-width="200"
                    prop="distributor_name"
                    sortable
                    label="经销商">
            </el-table-column>
            <el-table-column
                    prop="value1"
                    sortable
                    label="拜访目的"
                    width="120"
            >
            </el-table-column>
            <el-table-column
                    prop="contact_num"
                    sortable
                    label="拜访联系人人数"
                    width="150"
            >
            </el-table-column>
            <el-table-column
                    prop="checkin_time"
                    sortable
                    label="签入时间"
                    width="120px">
                <template slot-scope="scope">
                    <span v-if="scope.row.checkin_time ==='尚未签入'" style="color: #ED3B3F">尚未签入</span>
                    <span v-else-if="scope.row.checkin_time !=='尚未签入'">{{scope.row.checkin_time}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="checkout_time"
                    sortable
                    label="签出时间"
                    width="120px">
                <template slot-scope="scope">
                    <span v-if="scope.row.checkout_time ==='尚未签出'" style="color: #ED3B3F">尚未签出</span>
                    <span v-else-if="scope.row.checkout_time !=='尚未签出'">{{scope.row.checkout_time}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    width="90"
                    v-if="title === '管理员' && (GLOBAL.selectPeople_global === '' || GLOBAL.selectPeople_global === '0')"
                    prop="alias"
                    label="创建人"
                    sortable
            >
            </el-table-column>
            <el-table-column
                    fixed="right"
                    label-class-name="business_table_cell"
                    label="操作"
                    width="80"
                    style="color: #3b99f7"
            >
                <template slot-scope="scope">
                    <el-button
                            type="warning" size="small"
                            @click="handleDetail(scope.row)">详情
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-col style="margin-bottom: 20px">
            <pagination :page="page" @changePage="changePageClick"></pagination>
        </el-col>
        <!--新增门店巡查-->
        <el-dialog
                :visible.sync="businessVisit1"
                width="700px"
                :show-close="false"
                :before-close="handleClose"
                id="addBusinessDialog"
                style="vertical-align: center;: #FFF9F3">
            <div id="addBussiness">
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 15px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;font-size: 20px;padding-top: 10px">创建商务拜访
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div align="right">
                            <el-button type="primary" size="small" @click.stop="inputAddBusinessVisit" >
                                保存
                            </el-button>
                            <el-button type="danger" size="small" @click.stop="closeBusinessVisit1">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div id="back" style="margin-top: 20px;">
                    <el-form ref="addForm" :model="medial" label-width="24%" hide-required-asterisk>
                        <el-row style="margin: 0 auto;width: 80%">
                            <el-col>
                                <el-form-item label="拜访日期" class="business_star" :rules="[{required:true,message:'拜访日期不能为空'}]" prop="date">
                                    <el-date-picker
                                            v-model="medial.date"
                                            type="date"
                                            format="yyyy年M月d日"
                                            value-format="yyyy-MM-dd"
                                            placeholder="选择日期"
                                            style="width: 100%"
                                            :picker-options="pickerOptions"
                                            @change="changePicker">
                                    </el-date-picker>
                                </el-form-item>
<!--                                <el-form-item label="拜访类型">-->
<!--                                    <el-select v-model="medial.visit_type" placeholder="请选择拜访类型" style="width:70%">-->
<!--                                        <el-option-->
<!--                                                v-for="item in options_type"-->
<!--                                                :key="item.key"-->
<!--                                                :label="item.value1"-->
<!--                                                :value="item.key">-->
<!--                                        </el-option>-->
<!--                                    </el-select>-->
<!--                                </el-form-item>-->
                                <el-form-item label="拜访目的" class="business_star" :rules="[{required:true,message:'拜访目的不能为空'}]" prop="objective_id">
                                    <el-select v-model="medial.objective_id" placeholder="请选择拜访目的" style="width:100%" clearable>
                                        <el-option
                                                v-for="item in options_purpose"
                                                :key="item.key"
                                                :label="item.value1"
                                                :value="item.key">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row style="margin: 20px auto 0;width: 80%">
                            <el-col style="font-size:14px;color: #B8B8B8">请选择经销商</el-col>
                        </el-row>
                        <el-row style="width: 80%;height: 400px;margin: 10px auto;overflow: hidden;overflow-y:auto;" >
                            <el-col style="margin: 0px auto 10px;" v-for="(item,j) in addBusiness" >
                                <div @click.stop="medialImgClick(j)">
                                <el-col :style="{'background': item.onoff ? '#ecf3fc' : 'white',
                                'border':item.onoff?'1px solid #69a6fa':'1px solid #979797'
                                }">
                                <p style="margin: 10px 10px;font-weight: bold;font-size: 15px;">
                                    <span v-if="item.segment_name" style="text-align: center;color: white;background-color: #3998f7;padding: 0 5px;">
                                        {{item.segment_name}}
                                    </span>
                                    {{item.distributor_name}}</p>
                                <p style="margin: 0px 10px;margin-bottom: 34px;">
                                    <el-col :span="22" style="font-size: 13px; color: #B0B5B9;">
                                        {{item.address}}
                                    </el-col>
                                    <el-col :span="2" style="float: right">
                                        <img v-if="item.onoff ? true:false "   style="width: 25px;height: 25px;position:relative;top: 8px"
                                             src="../../../assets/images/speakers.png"/>
                                        <img v-else :src="check" alt="" style="width: 25px;height: 25px;position:relative;top: 8px">
                                    </el-col>
                                </p>
                                <p style="margin:10px 10px 5px;color: #7ED321;height: 14px;position: relative;top: -3px">
                                    <span v-if="item.distributor_grade" style="margin-right:20px;">{{item.distributor_grade}}</span>
                                    <span style="color: #3b99f7" v-if="item.contact_num>0">{{'联系人'+item.contact_num+'名'}}</span>
                                    <span style="color: red" v-else>暂无联系人</span>
                                    <span style="color:#3b99f7" v-if="item.inspection_num>0">| {{'本月拜访'+item.inspection_num+'次'}}</span>
                                    <span style="color:red" v-else>| 本月暂未拜访</span>
                                </p>
                                    <el-col style="margin-left: 10px;width: 400px">
                                        <span   v-for="(obj,j) in item.productArray"
                                                style="display: inline-block;padding: 4px;margin-bottom: 10px;font-size: 13px;font-weight: bold;
                                                background: #c8abed;color: white;border-radius: 4px;margin-right: 10px">
                                            {{obj.value1}}
                                        </span>
                                    </el-col>
                                </el-col>
                                </div>
                            </el-col>
                        </el-row>

                    </el-form>
                </div>
            </div>

        </el-dialog>
    </div>
</template>

<script>
    import navBar from '../../../components/navBar'
    import http from '../../../APIService/http'
    import pagination from '../../../components/pagination'
    import inputSelect from './components/inputSelect'
    import moment from 'moment'
    import check from '../../../assets/images/check.png'
    export default {
        name: "business",
        data() {
            return {
                id: "",
                role:'',
                loading: false,
                tags: ['辖区事务'],
                titleName:this.$store.getters.getUser.role ==='staff' ? this.$store.getters.getUser.alias:this.GLOBAL.peopleName_global,
                title:this.$store.getters.getUser.role ==='staff' ? this.$store.getters.getUser.alias:'管理员',
                subTitle: '商务拜访',
                tableData: [],
                visit_type:'',
                objective_id:'',
                options_type:[],
                options_purpose:[],
                check : check,
                businessVisit1:false,
                medialImg:false,
                selectPeople:this.$store.getters.getUser.user_id,
                selectPeopleManager:'',
                start_time:'',
                end_time:'',
                distributor_name:'',
                contact_name: '',
                options:[],
                medial:{},
                addBusiness:{},
                page: this.GLOBAL.page_business,
                pickerMinDate: '',
                searchForm:{},
                pickerOptions:{
                    // disabledDate: (time) => {
                    //     return time.getTime() + 24 * 3600 * 1000 < Date.now() || time.getTime() > Date.now() + 30*24 * 3600 * 1000
                    // }
                    onPick: ({ maxDate, minDate }) => {
                        this.pickerMinDate = minDate.getTime()
                        if (maxDate) {
                            this.pickerMinDate = ''
                        }
                    },
                    disabledDate: (time) => {
                        if (this.pickerMinDate !== '') {
                            const day30 = (30 - 1) * 24 * 3600 * 1000
                            let maxTime = this.pickerMinDate + day30
                            if (maxTime > new Date()) {
                                maxTime = new Date()
                            }
                            return time.getTime() > maxTime
                        }
                        return time.getTime() > Date.now()
                    }
                }
            }
        },
        components: {
            navBar,
            pagination,
            inputSelect
            // Upload
        },
        created () {
            this.init()
            this.getManager()
            this.role = this.$store.getters.getUser.role
        },
        mounted () {
            // document.getElementById('main').scrollTo(0, 0)
        },
        methods: {
            handleBackClick(){
                this.$router.go(-1)
            },
            async getManager(){
                try {
                    let data={
                        user_id : this.$store.getters.getUser.user_id,
                        tenant_id : this.$store.getters.getUser.tenant_id,
                    }
                    await http.post('/wapi/Calendar/getManger',data).then(res=>{
                        this.options = res.data
                        let obj={
                            user_id : '',
                            user_name:'所有下属'
                        }
                        this.options.unshift(obj)
                    })
                } catch (e) {

                }
            },
            medialImgClick(j){
                for(let i=0;i<this.addBusiness.length;i++){
                    this.addBusiness[i].onoff = false;
                    this.addBusiness[j].onoff = true;
                }
                this.$forceUpdate()
            },
            handleAddClick(){
                this.businessVisit1 = true;

                setTimeout(
                    ()=>{
                        this.getDistributorList();
                        this.medialBool();
                        // this.getDistributorTypeList();
                        this.getPurposeVisitList();
                    },100)

            },
            // 重置
            handleResetClick(){
                this.start_time='',
                    this.end_time='',
                    this.distributor_name=''
                this.contact_name=''
            },
            async init(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data={
                        tenant_id : user.tenant_id,
                        user_id : user.user_id,
                        date : this.date,
                        limit: this.page.size,
                        offset: this.page.current - 1,
                        distributor_name:this.distributor_name,
                        contact_name:this.contact_name,
                        owner_id : ''
                    }
                    if (this.start_time === '' || this.start_time == null){
                        data.start_time = ''
                    } else {
                        data.start_time=moment(this.start_time).format('YYYY-MM-DD')
                    }
                    if (this.end_time === '' || this.end_time == null){
                        data.end_time = ''
                    } else {
                        data.end_time=moment(this.end_time).format('YYYY-MM-DD')
                    }
                    if (user.role === 'staff') {
                        data.owner_id = this.selectPeople
                    }else {
                        data.owner_id =  this.GLOBAL.selectPeople_global
                        if(this.GLOBAL.selectOu_global!=''){
                            data.owner_id =''
                            data.ou_id = this.GLOBAL.selectOu_global
                        }
                    }
                    await http.post('/wapi/Business/getDistributorVisit',data).then(res=>{
                        if (res.success === true){
                            this.page.total = res.data.arrayCount
                            let traveArray = res.data.array
                            this.judeg(traveArray)
                            loading.close()
                        }
                    })
                }catch (e) {
                    loading.close()
                }
            },
            judeg(arr){
                let array = arr
                array.forEach((item,i)=>{
                    item.activity_date= moment(item.activity_date).format('YYYY年M月D日')
                    if(item.checkin_time){
                        item.checkin_time = moment(item.checkin_time).format('HH:mm:ss')
                    }else{
                        item.checkin_time = '尚未签入'
                    }
                    if(item.checkout_time){
                        item.checkout_time = moment(item.checkout_time).format('HH:mm:ss')
                    }else{
                        item.checkout_time = '尚未签出'
                    }
                })
                // console.log(array)
                this.tableData = array
            },
            changePageClick(page, size) {
                if (page) {
                    this.page.current = page
                }
                if (size) {
                    this.page.size = size
                }
                this.init()
            },
            changePicker(){
                this.getDistributorList()
            },
            // 获取经销商
            async getDistributorList(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    let user = this.$store.getters.getUser
                    if(this.medial.date){
                        var str = this.medial.date
                        var year = str.split('')[0]+str.split('')[1]+str.split('')[2]+str.split('')[3];
                        var month = str.split('')[5]+str.split('')[6];
                        var data={
                            tenant_id : user.tenant_id,
                            user_id : user.user_id,
                            month:year+month,
                        }
                    }else{
                        var data={
                            tenant_id : user.tenant_id,
                            user_id : user.user_id,
                        }
                    }

                    if (user.role == 'staff') {
                        data.owner_id = this.selectPeople
                    }else {
                        data.owner_id = this.GLOBAL.selectPeople_global
                    }
                    await http.post('/wapi/Business/getDistributorList',data).then(res=>{
                        if(res.success === true){
                            this.addBusiness = res.data.array;
                             console.log(this.addBusiness)
                        }
                    })
                    loading.close()
                }catch (e) {
                    loading.close()
                }
            },
            // 获取拜访类型
            async getDistributorTypeList(){
                // let loading = this.$loading({
                //     lock: true,
                //     text: '拼命加载中',
                //     spinner: 'el-icon-loading',
                //     background: 'rgba(0, 0, 0, 0.7)'
                // });
                try{
                    let data={
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        user_id:this.$store.getters.getUser.user_id,
                    }
                    await http.post('/wapi/Business/getDistributorTypeList',data).then(res=>{
                        this.options_type = res.data
                    })
                    // loading.close()
                }catch (e) {
                    // loading.close()
                    return e
                }
            },
            // 获取拜访目的
            async getPurposeVisitList(){
                // let loading = this.$loading({
                //     lock: true,
                //     text: '拼命加载中',
                //     spinner: 'el-icon-loading',
                //     background: 'rgba(0, 0, 0, 0.7)'
                // });
                try{
                    let data={
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        user_id:this.$store.getters.getUser.user_id,
                    }
                    await http.post('/wapi/Business/getPurposeVisitList',data).then(res=>{
                        if(res.success == true){
                            this.options_purpose = res.data
                        }

                    })
                    // loading.close()
                }catch (e) {
                    // loading.close()
                    return e
                }
            },
            medialBool(){
                let arr = this.addBusiness;
                for(let i=0;i<arr.length;i++){
                    arr[i].onoff = false;
                }
            },
            inputAddBusinessVisit(){
                this.$refs["addForm"].validate(valid=> {
                    if (!valid) {
                        return false
                    } else {
                        this.addBusinessVisit()
                    }
                })
            },
            // 新增门店巡查
            async addBusinessVisit(){
                try{
                    let arr = {};
                    for(let i=0;i<this.addBusiness.length;i++){
                        if(this.addBusiness[i].onoff === true){
                            arr = this.addBusiness[i]
                        }
                    }
                    if (!(this.medial.date)){
                        this.$message({
                            type:'error',
                            message: '请选择拜访时间'
                        })
                        //loading.close()
                        return false;
                    }
                    // if (!(this.medial.visit_type)){
                    //     this.$message({
                    //         type:'error',
                    //         message: '请选择拜访类型'
                    //     })
                    //     loading.close()
                    //     return false;
                    // }
                    if (!(this.medial.objective_id)){
                        this.$message({
                            type:'error',
                            message: '请选择拜访目的'
                        })
                       // loading.close()
                        return false;
                    }
                    if(Object.keys(arr).length==0){
                        this.$message({
                            type:'error',
                            message: '请选择经销商'
                        })
                        //loading.close()
                        return false;
                    }
                    let loading = this.$loading({
                        lock: true,
                        text: '拼命加载中',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    let user = this.$store.getters.getUser
                    let data={
                        tenant_id : user.tenant_id,
                        user_id : user.user_id,
                        date:this.medial.date,
                        distributor_id:arr.distributor_id,
                        account_id:arr.account_id,
                        visit_type:this.medial.visit_type,
                        objective_id:this.medial.objective_id,
                        territory_id : arr.territory_id,
                        segment_id  : arr.segment_id,
                        reference_obj : arr.reference_obj,
                        reference_id : arr.reference_id
                    }
                    if (!data.territory_id){
                        data.territory_id = ''
                    }
                    await http.post('/wapi/Business/addDistributorVisit',data).then(res=>{
                        if(res.success === true){
                            //this.init()
                            this.$message({
                                type: 'success',
                                message: '保存成功',
                            })
                            this.businessVisit1=false
                            let value1=''
                            for(let i=0;i<this.options_purpose.length;i++){
                                if(this.options_purpose[i].key==this.medial.objective_id){
                                    value1=this.options_purpose[i].value1
                                }
                            }
                            let obj={
                                activity_date: moment(this.medial.date).format('YYYY年M月D日'),
                                activity_id: res.data,
                                alias: user.alias,
                                checkin_time: "",
                                checkout_time: "",
                                created_by: user.user_id,
                                date: this.medial.date,
                                distributor_id:arr.distributor_id,
                                distributor_name: arr.distributor_name,
                                value1: value1
                            }
                            // console.log(obj,12)
                            this.$router.push({
                                name:'businessDetails',
                                params:obj
                            })
                            this.medial={}
                        }else {
                            this.$message({
                                type: 'error',
                                message: res.message,
                            })
                            loading.close()
                        }
                    })

                    loading.close()
                }catch (e) {
                    loading.close()
                }

            },

            handleDetail(row){
                this.GLOBAL.page_business = this.page
                this.searchForm = row
                this.$router.push({name:'businessDetails',params:row})
            },
            handleSelectInputClick(j){

                for (let i=0;i<this.options.length;i++){
                    if (j === this.options[i].user_id){
                        this.titleName =this.options[i].user_name
                    }
                }
                this.GLOBAL.selectPeople_global = j
                this.titleName = this.GLOBAL.peopleName_global
                this.init()
            },
            handleQueryClick(){
                this.page= {
                    current: 1,
                    size: 5,
                    total: 0
                }
                this.init()
            },
            closeBusinessVisit1(){
                this.businessVisit1=false;
                this.$refs['addForm'].resetFields()
            },
            handleClose(){

            }
        },
        beforeRouteLeave(to, from, next){

            // 打开详情页（或者下一个任意界面）之前，把筛选条件保存到localStorage，如果离开列表页并且打开的不是详情页则清除，也可以选择不清除
            if (to.name === 'businessDetails') {
                let condition = JSON.stringify(this.searchForm)
                localStorage.setItem('condition', condition)
            }else{
                localStorage.removeItem('condition')
            }
            if (to.name !== 'businessDetails'){
                this.GLOBAL.page_business = {
                    current: 1,
                    size: 5,
                    total: 0
                }
            }
            next()
        }
    }
</script>

<style scoped>
    /*#business {*/
    /*    background: #fff;*/
    /*    padding: 0px 50px;*/
    /*    height: 100%;*/
    /*    box-sizing: border-box;*/
    /*}*/
    #business >>>.el-form-item__label{
        font-size: 16px;
        color: #000000;
        padding-left: 0px;
        text-align: left;
        padding-right: 40px;
    }

    #business >>>.el-table_1_column_7{
        color: #3b99f7;
    }
    #business >>>.el-table th{
        padding: 7px 0px;
    }
    #business >>>.el-table td{
        padding: 7px 0px;
    }
    #back >>>.el-form-item__label{
        font-size: 16px;
        color: #000000;
        padding-left: 0px;
        text-align: left;
        padding-right: 40px;
    }


    #business >>>.el-dialog__body{
        padding-top:0;
        padding-bottom: 30px;
    }
    #business >>> .business_table_cell{
        color: #2b92fa !important;
    }
    #business >>> .el-button--warning {
        color: #FFF;
        background-color: #FF9901;
        border-color: #FF9901;
    }
    #business >>> .el-button--warning:hover {
        background: #ebb563;
        border-color: #ebb563;
        color: #FFF;
    }
    #business >>> .business_star label:after{
        content: '*';
        color: #F56C6C;
        margin-left: 4px;
    }
    #business >>> .el-button{
        font-size: 13px;
    }
    #addBusinessDialog >>> .el-dialog__body{
        padding: 10px 20px 20px;
    }
    #business >>> .el-dialog__header{
        padding-top: 0px;
    }
</style>




// WEBPACK FOOTER //
// src/pages/calendar/components/business.vue